var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateFormatService } from './services/date-format.service';
var DateFormat = /** @class */ (function (_super) {
    __extends(DateFormat, _super);
    function DateFormat(dateFormatService) {
        var _this = _super.call(this, 'en-US') || this;
        _this.dateFormatService = dateFormatService;
        return _this;
    }
    DateFormat.prototype.format = function (date, displayFormat) {
        var locale = this.dateFormatService.getLocale();
        var format = this.dateFormatService.getFormat();
        return date.locale(locale).format(format);
    };
    return DateFormat;
}(MomentDateAdapter));
export { DateFormat };
// export const APP_DATE_FORMATS =
// {
//    parse: {
//        dateInput: {month: 'short', year: 'numeric', day: 'numeric'}
//    },
//    display: {
//        dateInput: 'input',
//        monthYearLabel: { year: 'numeric', month: 'numeric' },
//        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
//        monthYearA11yLabel: {year: 'numeric', month: 'long'},
//    }
// }
